/* global fetch */
import { Fragment, h, render } from 'preact';
import { useState, useRef, useEffect } from 'preact/hooks'; /** @jsx h */

import CodePanel from './CodePanel';

import './ViewerVerification.css';
import Spinner from '../../utils/Spinner';
import NoAutoCompleteInput from '../../utils/NoAutoCompleteInput';

const { codeword } = window.CONFIG;

const ViewerVerification = () => {
    const [codewordVerified, setCodewordVerified] = useState(false);
    const [enteredCodeword, setEnteredCodeword] = useState(
        codeword.toUpperCase()
    );
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [unableToRetry, setUnableToRetry] = useState(false);

    const input = useRef(null);

    useEffect(() => {
        input.current.focus();
        if (codeword !== '' && codeword) {
            handleCodewordSubmit();
        }
    }, []);

    const handleKeyDown = e => {
        if (e.keyCode === 13) {
            handleCodewordSubmit(e);
        }
    };

    const handleCodeword = async e => {
        const inputField = e.target;
        const start = inputField.selectionStart;
        const end = inputField.selectionEnd;

        await setEnteredCodeword(inputField.value.toUpperCase());
        inputField.setSelectionRange(start, end);
    };

    const handleCodewordSubmit = async () => {
        setLoading(true);
        const response = await fetch('/codeword', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ codeword: enteredCodeword })
        });

        if (response.status === 200) {
            setCodewordVerified(true);
            setErrorMessage('');
        } else if (response.status === 401) {
            setErrorMessage('Ugyldig kodeord.');
        }
        setLoading(false);
    };

    const handleCodeSubmit = async code => {
        setLoading(true);
        const response = await fetch('/verify-code', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ codeword: enteredCodeword, code })
        });
        if (!response.ok) {
            let error = await response.text();
            try {
                error = JSON.parse(error);
                console.log(error);
                setErrorMessage(error.errorMessage);
                setUnableToRetry(error.tooManyAttempts);
            } catch (e) {
                // Couldnt't parse JSON. Showing error
                setErrorMessage('Noe gikk galt.');
                setUnableToRetry(true);
            }
        } else {
            const newHtml = await response.text();
            document.open('text/html');
            document.write(newHtml);
            document.close();
        }

        setLoading(false);
    };

    const returnToStart = () => {
        setLoading(true);
        setCodewordVerified(false);
        setEnteredCodeword('');
        setErrorMessage('');
        setUnableToRetry(false);
        setLoading(false);
    };

    return (
        <Fragment>
            <header>
                <img
                    id="logo"
                    className="header-logo"
                    src="/assets/logo_with_text.svg"
                    alt="Stiftelsen Norsk Luftambulanse"
                />
            </header>
            <div className="flex-container">
                <div className="viewer-verification">
                    {loading ? (
                        <Spinner />
                    ) : codewordVerified ? (
                        <CodePanel
                            handleCodeSubmit={handleCodeSubmit}
                            returnToStart={returnToStart}
                            errorMessage={errorMessage}
                            unableToRetry={unableToRetry}
                        />
                    ) : (
                        <Fragment>
                            <h2>Skriv inn kodeord fra SMS</h2>
                            <div className="wrap">
                                <NoAutoCompleteInput
                                    ref={input}
                                    type="text"
                                    value={enteredCodeword}
                                    className="codeword-input"
                                    onInput={handleCodeword}
                                    onKeyDown={handleKeyDown}
                                />
                            </div>
                            <div className="error-message">
                                <p>{errorMessage}</p>
                            </div>
                            <button
                                className="confirm-button"
                                onClick={handleCodewordSubmit}
                            >
                                Send
                            </button>
                        </Fragment>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

render(<ViewerVerification />, document.body);
